// The server turns an image into a PDF page; anything else is refused there as well.
export const ANNEX_TYPES = ['application/pdf', 'image/png', 'image/jpeg'];
export const ANNEX_ACCEPT = ANNEX_TYPES.join(',');
// nginx caps a request body at 10M; a larger file fails as a reset, not as a readable 400.
export const MAX_ANNEX_BYTES = 10 * 1024 * 1024;

/** The files on the clipboard. Some browsers leave `files` empty and carry them in `items`. */
export function clipboardFiles(data) {
    if (!data) return [];
    const files = Array.from(data.files || []);
    if (files.length) return files;
    return Array.from(data.items || [])
        .filter(item => item.kind === 'file')
        .map(item => item.getAsFile())
        .filter(Boolean);
}

/** True when a paste into a field also carries text: Excel and Word put a picture of the
 *  copied cells beside the text, and the text is what was meant. */
export function pasteBelongsToField(event) {
    const target = event.target;
    const editable = !!target && (/^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName) || target.isContentEditable);
    if (!editable) return false;
    const types = Array.from(event.clipboardData?.types || []);
    return types.includes('text/plain') || types.includes('text/html');
}

/** The paste shortcut as this machine labels it. */
export function pasteShortcut(nav = typeof navigator === 'undefined' ? undefined : navigator) {
    return /Mac|iPhone|iPad/.test(nav?.platform || nav?.userAgent || '') ? '⌘V' : 'Strg+V';
}

const pad = n => String(n).padStart(2, '0');
const EXTENSION = { 'application/pdf': 'pdf', 'image/png': 'png', 'image/jpeg': 'jpg' };

/** A pasted bitmap arrives as "image.png", and several of those cannot be told apart in the list. */
const isGenericName = name => !name || /^image\.(png|jpe?g)$/i.test(name);

function pastedName(type, now, count) {
    const date = `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()}`;
    const time = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    return `Bild ${date} ${time}${count > 1 ? ` (${count})` : ''}.${EXTENSION[type]}`;
}

/** Files ready to upload, a pasted bitmap renamed, and a message for those that cannot be. */
export function prepareAnnexFiles(files, now = new Date()) {
    const accepted = [];
    const problems = [];
    let renamed = 0;
    files.forEach(file => {
        if (!ANNEX_TYPES.includes(file.type)) {
            problems.push(`${file.name || 'Die Datei'}: nur PDF, PNG oder JPEG können angefügt werden.`);
        } else if (file.size > MAX_ANNEX_BYTES) {
            problems.push(`${file.name || 'Die Datei'} ist größer als 10 MB.`);
        } else if (isGenericName(file.name)) {
            renamed += 1;
            accepted.push(new File([file], pastedName(file.type, now, renamed), { type: file.type }));
        } else {
            accepted.push(file);
        }
    });
    return { files: accepted, message: problems.join(' ') };
}
